// extracted by mini-css-extract-plugin
export default {"root":"DeleteFlagModal_root__G4MXv","container":"DeleteFlagModal_container__Sy1Y1"};